<template>
  <div v-if="modal">
    <div class="modal-pdv modal-small show" tabindex="-1" id="modalComprovante" :class="{'modal-gestor': gestor}">
      <div class="modal-pdv-content">
        <form @submit.prevent="confirmar">
          <div class="container-fluid p-0">
            <div class="text-center px-3 mb-3" v-if="menu === 1">
              <h6 class="mb-3 font-weight-bold">Comprovante</h6>
              <div class="row no-gutters">
                <div class="col-12 p-1">
                  <button id="btnNaoFiscal" class="btn btn-third btn-block py-3" type="button" @click="imprimirOpt()"><i class="fa fa-print mr-1"></i> <span class="small">Comprovante não fiscal</span></button>
                </div>
                <div class="col-12 p-1" v-if="comanda.status === '2' && (configs.bling || configs.sat || configs.nfce) && comanda.modelo !== '55'">
                  <button type="button" id="btnCupom" class="btn btn-secondary btn-block py-3" @click="prepararNfce()"><i class="fa fa-file-invoice-dollar mr-2"></i>
                    <span class="small">{{ comanda.id_nfe && comanda.status_nfe === '2' ? 'Reimprimir' : 'Gerar' }} Cupom Fiscal</span><span class="small" v-if="configs.bling"> (Bling)</span>
                  </button>
                </div>
                <div class="col-12 p-1" v-if="comanda.status === '2' && (!comanda.id_nfe || comanda.modelo === '55') && configs.nfe">
                  <button id="btnNFe" class="btn btn-info btn-block py-3" type="button" @click="gerarNfe()"><i class="fa fa-file-invoice mr-2"></i>
                    <span class="small">{{ comanda.id_nfe && comanda.status_nfe === '2' ? 'Baixar DANFE' : 'Gerar NF-e' }}</span>
                  </button>
                </div>
                <div class="col-6 p-1" v-if="comanda.status === '2'">
                  <button id="btnFichas" class="btn btn-warning btn-block py-3" type="button" @click="gerarFichas()"><i class="fa fa-list-alt mr-1"></i> <span class="small">Fichas de Consumo</span></button>
                </div>
                <div class="col-6 p-1" v-if="comanda.status === '2'">
                  <button id="btnWPP" class="btn btn-success btn-block py-3" type="button" @click="toggleWpp()"><span class="icon-whatsapp mr-1"></span> <span class="small">Enviar WhatsApp</span></button>
                </div>
              </div>
            </div>
            <div class="px-3 mb-3" v-else-if="menu === 2">
              <h6 class="font-weight-bold mb-3">Enviar por WhatsApp</h6>
              <hr>
              <div class="mb-2">
                <label class="mb-0">Celular</label>
                <the-mask type="tel" :mask="['(##) ####-####', '(##) #####-####']" class="form-control" :id="input" v-model="dados.celular" placeholder="(##) #####-###" minlength="8" required/>
              </div>
              <div>
                <label class="mb-0">Mensagem</label>
                <textarea class="form-control" rows="5" v-model="dados.mensagem" required style="resize: none"></textarea>
              </div>
            </div>
            <div class="px-3 mb-3" v-else-if="menu === 3">
              <h6 class="font-weight-bold mb-0" v-if="nfe.erro">Cupom Fiscal com erros!</h6>
              <h6 class="font-weight-bold mb-0" v-else>Emissão de Cupom Fiscal</h6>
              <hr>
              <div class="mb-3">
                <div v-if="!nfe.id_nfe">
                  <div class="alert alert-info mb-2" v-show="dadosNfe.cpf_cnpj.length > 11">
                    Para clientes com <b>CNPJ</b> e <b>Inscrição Estadual</b>, <a href="javascript:" @click="gerarNfe()">clique aqui</a> para gerar a NF-E.
                  </div>
                  <div class="mb-2">
                    <label class="small mb-0">CPF/CNPJ na nota</label>
                    <the-mask typeof="number" id="cpf_cnpj" :mask="['###.###.###-##', '##.###.###/####-##']" class="form-control" v-model="dadosNfe.cpf_cnpj" placeholder="CPF ou CNPJ"/>
                  </div>
                  <div class="mb-4">
                    <label class="small mb-0">Nome do cliente</label>
                    <input type="text" id="nome_clientenfe" class="form-control" v-model="dadosNfe.nome_cliente"
                           placeholder="Nome completo" required/>
                  </div>
                </div>
                <div v-else>
                  <div><b>Modelo</b>: {{ nfe.modelo | modelo }}</div>
                  <div><b>Status</b>: {{ nfe.status | statusNfe }}</div>
                  <div><b>Número</b>: {{ nfe.numero }}</div>
                  <div v-if="nfe.serie"><b>Série</b>: {{ nfe.serie }}</div>
                </div>
                <div class="alert alert-warning mt-2" v-html="nfe.erro" v-if="nfe.erro"></div>
                <div class="alert alert-warning mt-2" v-if="!nfe.erro && nfe.status === '3'">Esta nota foi rejeitada, por favor acesse o link abaixo para conferir o erro.</div>
                <div class="text-center" v-if="nfe.external_id && nfe.status !== '2'">
                  <a :href="`https://www.bling.com.br/notas.fiscais.nfces.php#edit/${nfe.external_id}`" class="small" target="_blank">Acessar NFC-e <i class="fa fa-external-link-alt"></i></a>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-content-footer bg-light border-top p-2 d-flex justify-content-between">
            <button type="button" class="btn btn-outline-dark p-3" @click="toggleModal(false)">
              Fechar
            </button>
            <a id="msgWhatsApp" :href="`https://wa.me/55${dados.celular}?text=${encodeURIComponent(dados.mensagem)}`"
               target="_blank" class="btn btn-success p-3" v-if="menu === 2">
              Enviar
            </a>
            <button @click="prepararNfce" id="emitirNfe" class="btn btn-success p-3" v-if="menu === 3 && nfe.status !== '2'" style="min-width: 136px">
              <span class="small">{{ nfe.id_nfe ? 'Autorizar Cupom' : 'Emitir Cupom'}}</span>
            </button>
            <button v-else-if="nfe.status === '2'" class="btn btn-third p-3" @click="prepararImpressaoNfce(nfe)">
              Imprimir <i class="fa fa-print ml-1"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
    <fichas-consumo :fichas="fichas" v-if="fichas.length"/>
  </div>
</template>

<script>
  import FichasConsumo from "@/components/pdv/FichasConsumo";
  import Tooltip from "@/components/commons/Tooltip";
  export default {
    name: "ModalOption",
    components: {Tooltip, FichasConsumo},
    props: ['gestor', 'empresa'],
    data() {
      return {
        modal: false,
        menu: 1,
        reimprimir: false,
        finalizar: false,
        token: localStorage.getItem('key'),
        empresa_token: null,
        input: this.$helpers.ID(),
        dados: {
          celular: '',
          mensagem: ''
        },
        comanda: {},
        nfe: { id_nfe: '', linkDanfe: null, erro: null },
        dadosNfe: {},
        fichas: [],
        configs: {
          nfe: false,
          sat: false,
          nfce: false,
          bling: false
        }
      }
    },

    methods: {
      toggleModal(n) {
        this.modal = n;
        this.$nextTick(() => {
          this.$helpers.toggleModal(n, 'modalComprovante', this.toggleModal);
          this.$helpers.focusElement(this.modal ? 'btnNaoFiscal' : 'pesquisar');
        });

        if (!n) {
          if (this.finalizar && this.$route.name !== 'NovoPDV') {
            this.$router.push('/pdv');

          } else if (!this.finalizar && this.nfe.id_nfe && !this.comanda.id_nfe) {
            this.$emit('atualizar', this.nfe);
          }
        }
      },

      toggleWpp() {
        this.menu = 2;
        this.$nextTick(() => {
          this.$helpers.focusElement(this.input);
        })
      },

      imprimirOpt() {
        this.$emit('imprimir', this.comanda.id_comanda);
        this.toggleModal(false);
      },

      confirmar() {
        if (this.menu === 2 && this.dados.celular.length >= 10) {
          window.open(document.getElementById('msgWhatsApp').href,"_blank")
        }
      },

      prepararNfce() {
        if (this.comanda.id_nfe && this.comanda.status_nfe === '2') {
          this.prepararImpressaoNfce(this.comanda);
          return;
        }

        if (this.menu < 3) {
          this.menu = 3;
          this.$nextTick(() => {
            this.$helpers.focusElement('cpf_cnpj');
          });

          return;
        }

        if (this.dadosNfe.cpf_cnpj.trim() && (![11,14].includes(this.dadosNfe.cpf_cnpj.length))) {
          this.$swal('Por favor informe um CPF ou CNPJ válido!').then(() => {
            this.$helpers.focusElement('cpf_cnpj');
          });

          return;
        }

        if (this.dadosNfe.nome_cliente.trim() !== 'Consumidor Final' && (![11,14].includes(this.dadosNfe.cpf_cnpj.length))) {
          this.$swal('Você precisa informar o CPF/CNPJ do cliente caso queira informar o nome na nota. Você também informar "Consumidor Final".').then(() => {
            this.$helpers.focusElement('cpf_cnpj');
          });
        }

        this.gerarNfce();
      },

      gerarNfce() {
        if (this.comanda.id_nfe && this.comanda.status_nfe === '2') {
          this.prepararImpressaoNfce(this.comanda);

        } else {
          this.$store.state.load = "Por favor aguarde";
          this.dadosNfe.id_comanda = this.comanda.id_comanda;
          const url = this.configs.bling ? "integrador/bling/nfce/" : (this.configs.nfce ? "fiscal/nfce/gerar/" : "fiscal/sat/gerar/");

          this.$http.post(url + this.token, this.dadosNfe)
            .then(res => {
              this.$store.state.load = false;

              if (res.data.id_nfe) {
                this.nfe = res.data;
                this.menu = 3;

                if (this.configs.bling && this.nfe.status === '1') {
                  this.autorizarNfce();

                } else if (this.nfe.status !== '2') {
                  this.finalizar = false;
                }

              } else {
                this.$swal("Não foi possível gerar este Cupom Fiscal");
              }

            }, res => {
              this.$store.state.load = false;
              this.$swal(res.data.msg || 'Erro temporário');
            });
        }
      },

      gerarNfe() {
        if (this.comanda.id_nfe && this.comanda.status_nfe === '2') {
          this.prepararImpressaoNfce(this.comanda);

        } else {
          this.$swal({
            text: "Você será direcionado para o Portal para finalizar a emissão da Nota Fiscal. Deseja continuar?",
            buttons: ["Cancelar", "Sim"],
          }).then((res) => {
            if (res) {
              let isHomolog = window.location.href.startsWith('https://hhh.');
              let isBeta = window.location.href.startsWith('https://beta.');
              const url = isHomolog ? "https://hhh.portal.lecard.delivery/" : (isBeta ? "https://beta.portal.lecard.delivery/" : "https://portal.lecard.app/");
              window.open(url + 'fiscal/nfe?venda=' + this.comanda.id_comanda, "_blank");
            }
          })
        }
      },

      autorizarNfce() {
        this.$store.state.load = "Autorizando documento fiscal";
        this.$http.post("integrador/bling/nfce/autorizar/" + this.token, this.nfe)
          .then(res => {
            this.$store.state.load = false;

            if (!res.data.success) {
              this.$swal(res.data.msg || "Não foi possível autorizar a NFC-e");
            }

            if (res.data.nfe) {
              this.nfe = res.data.nfe;
            }

          }, res => {
            this.$store.state.load = false;
            this.$swal(res.data.msg || 'Erro temporário');
          });
      },

      prepararImpressaoNfce(nfe) {
        if (nfe.modelo === '55') {
          this.$helpers.openArquivo(this, this.base_server + 'api/fiscal/nfce/imprimir/' + nfe.id_nfe, "pdf");
          return;
        }

        let url = "";

        if (this.configs.bling) {
          url = "api/integrador/bling/nfce/imprimir/" + nfe.id_nfe;

        } else if (nfe.modelo === '59') {
          url = "api/fiscal/sat/comprovante?id=" + nfe.id_nfe;

        } else {
          url = `public/comprovante/${this.empresa_token}/${this.comanda.id_comanda}/${this.comanda.id_contador}?fiscal=true`
        }

        this.$store.state.load = "Gerando cupom..";
        this.$http.get(this.base_server + url).then((res) => {
          this.$store.state.load = false;

          if (res.body) {
            this.imprimirNfce(res.body);

          } else {
            this.$swal('Erro temporário');
          }

        }, (res) => {
          this.$store.state.load = false;
          this.$swal(res.data.msg || 'Erro temporário');
        });
      },

      imprimirNfce(content) {
        const cf = this.$store.state.impressora;
        const device = cf.devicePdv || null;
        const dataImpressao = {
          content,
          copies: 1,
          isPdv: true,
          status: 1,
          nome_documento: 'Cupom Venda ' + (this.comanda.id_contador || this.comanda.id_comanda),
          device,
          fonte_fixa: 9,
          zoom: "6px",
          impressora: {
            device,
            zoom: "6px",
            largura: cf.largura || '100%'
          }
        }

        this.$helpers.imprimirComprovante(this, localStorage.getItem('token'), [dataImpressao], cf.mobilePrint);
      },

      normalizeDivisoes(p) {
        let divisoes = [];
        p.forEach(obj => {
          divisoes.push(obj.nome_produto)
        });

        return divisoes.join(", ");
      },

      gerarFichas() {
        if (this.reimprimir) {
          this.$helpers.confirmarSenhaAdm(this, () => {
            this.imprimirFichas();
          });

        } else {
          this.imprimirFichas();
        }
      },

      imprimirFichas() {
        this.fichas = [];
        this.comanda.itens.forEach(p => {
          const qtd = p.produto.id_medida === '1' ? parseInt(p.quantidade) : 1;
          const nome_produto = (p.produto.id_medida === '2' ? `${parseFloat(p.quantidade).toFixed(3)}kg` : '') +
          p.produto.nome_produto + (p.divisoes.length > 0 ? " (" + this.normalizeDivisoes(p.divisoes) + ")" : "");

          for (let i = 0; i < qtd; i++) {
            this.fichas.push({
              nome_produto,
              id_comanda_produto: `${p.produto.id_comanda_produto}${i}`,
              quantidade: p.quantidade,
              adicionais: p.adicionais || [],
              id_venda: this.comanda.id_contador || this.comanda.id_comanda,
              empresa: this.comanda.empresa.nome_fantasia,
              data_comanda: this.comanda.data_comanda,
              mesa: this.comanda.mesa,
              ref_comanda: this.comanda.ref_comanda
            });
          }
        });

        this.$nextTick(() => {
          if (!this.fichas.length) {
            return;
          }

          const html = document.getElementById("fichaConsumo");

          if (html) {
            const cf = this.$store.state.impressora;
            const empresa = this.empresa_token;
            const device = cf.devicePdv || null;
            let dataImpressao = [];
            let fichas;

            if (this.configsPdv.cut_fichas) {
              fichas = Array.from(html.children).map(el => el.outerHTML);

            } else {
              fichas = [html.outerHTML];
            }

            fichas.forEach(content => {
              dataImpressao.push({
                content,
                copies: 1,
                isPdv: true,
                status: 1,
                nome_documento: 'Fichas da Venda ' + this.comanda.id_comanda,
                zoom: "9px",
                device,
                impressora: {
                  device,
                  zoom: "9px",
                  largura: cf.largura || '100%'
                }
              });
            });

            this.$helpers.imprimirComprovante(this, empresa, dataImpressao, cf.mobilePrint);
            this.reimprimir = true;
            this.toggleModal(false);
          }
        });
      },

      abrirComprovante(comanda, reimprimir, finalizar) {
        this.toggleModal(true);
        this.reimprimir = !!reimprimir;
        this.finalizar = finalizar;
        this.menu = 1;
        this.comanda = comanda || {};
        const config = this.empresa && this.empresa.configs ? this.empresa.configs : this.$store.state.pdv;
        this.empresa_token = config.token || localStorage.getItem('token');

        this.configs = {
          nfe: config.nfe_habilitado === '1',
          sat: config.sat_habilitado === '1',
          nfce: config.nfce_habilitado === '1',
          bling: config.integracao_bling === '1'
        };

        this.nfe = { id_nfe: null, linkDanfe: null, erro: null };
        const cliente = this.comanda.cliente || {};
        this.dadosNfe = {
          cpf_cnpj: cliente.cpf_cnpj || '',
          nome_cliente: cliente.cpf_cnpj && cliente.nome_cliente ? cliente.nome_cliente : 'Consumidor Final'
        };

        const celular = cliente.telefone || ""
        const mensagem = "Olá, confira os dados do seu comprovante no link abaixo:\n\n" +  `${this.base_server}public/comprovante/${this.empresa_token}/${this.comanda.id_comanda}/${this.comanda.id_contador}`;
        this.dados = { celular: celular ? celular.replace(/[^0-9]+/g,"") : "", mensagem };
      }
    },

    created() {
      this.$parent.$on('abrirComprovante', (comanda, reimprimir, finalizar) => {
        this.abrirComprovante(comanda, reimprimir, finalizar);
      });
    },

    computed: {
      configsPdv() {
        return this.$store.state.pdv.json_config;
      }
    },

    filters: {
      statusNfe(value) {
        switch (value) {
          case '1':
            return 'Pendente';
          case '2':
            return 'Autorizado';
          case '4':
            return 'Cancelado';
          default:
            return 'Rejeitado';
        }
      },

      modelo(val) {
        switch (val) {
          case '55':
            return 'NF-e';
          case '59':
            return 'Sat Fiscal';
          default:
            return 'NFC-e';
        }
      },

      qtd(value) {
        if (value && !isNaN(value)) {
          return parseFloat(value).toFixed();
        }
      },

      medida(value) {
        if (value && !isNaN(value)) {
          return parseFloat(value).toFixed(3) + " kg";
        }
      }
    }
  }
</script>

<style scoped>
.modal-gestor {
  z-index: 2000;
}
.modal-gestor .modal-pdv-content {
  margin-top: 72px!important;
}
.modal-pdv.modal-small .modal-pdv-content {
  width: 42%;
}
</style>
